import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import WorkQueueProvider from './context/WorkQueueProvider.jsx';
import WorkQueueLayout from './pages/WorkQueueLayout.jsx';
import InboxViewPage from './pages/InboxViewPage.jsx';
import ActivityLogPage from './pages/ActivityLogPage.jsx';
import { WORK_QUEUE_PATHS } from './constants/inboxViews.js';

function LegacyInboxRedirect() {
  const { eventId } = useParams();
  return (
    <Navigate
      to={eventId ? WORK_QUEUE_PATHS.event(eventId) : WORK_QUEUE_PATHS.root}
      replace
    />
  );
}

function LegacyEventDetailRedirect() {
  const { eventId } = useParams();
  return <Navigate to={WORK_QUEUE_PATHS.event(eventId)} replace />;
}

/**
 * Work-queue domain root: provides shared state and defines the domain routes.
 * Paths are relative to the shell mount point (`work-queues/*`).
 *
 * - `/work-queues`           → Inbox split (auto-selects first event)
 * - `/work-queues/:eventId`  → Inbox split with selection
 * - `/work-queues/activity`  → Activity Log (Audit Ledger)
 */
const WorkQueue = () => (
  <WorkQueueProvider>
    <Routes>
      <Route element={<WorkQueueLayout />}>
        <Route
          index
          element={
            <ProtectedRoute>
              <InboxViewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="activity"
          element={
            <ProtectedRoute>
              <ActivityLogPage />
            </ProtectedRoute>
          }
        />
        <Route path="inbox" element={<LegacyInboxRedirect />} />
        <Route path="inbox/:eventId" element={<LegacyInboxRedirect />} />
        <Route
          path=":eventId"
          element={
            <ProtectedRoute>
              <InboxViewPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="event/:eventId" element={<LegacyEventDetailRedirect />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  </WorkQueueProvider>
);

export default WorkQueue;
